import { Users, Trophy, Swords, History, PlusSquare } from 'lucide-react';

const Navigation = ({ view, setView, setShowResetConfirm, showSetup, onShowPrevious }) => {
    const navItems = [
      { id: 'setup', label: 'Jogadores', icon: Users, show: showSetup },
      { id: 'matches', label: 'Partidas', icon: Swords, show: true },
      { id: 'ranking', label: 'Ranking', icon: Trophy, show: true },
    ];
  
    return (
      <nav className="my-6 bg-slate-900/80 backdrop-blur-sm border border-slate-800/80 rounded-2xl p-2">
        <div className="flex items-center gap-2">
          {navItems.map(item => (
            item.show && (
              <button
                key={item.id}
                onClick={() => setView(item.id)}
                className={`flex-1 flex items-center justify-center gap-2.5 text-sm font-medium p-2.5 rounded-lg transition-all duration-200 ease-in-out ${
                  view === item.id 
                    ? 'bg-slate-700/60 text-slate-100 shadow-md' 
                    : 'text-slate-400 hover:bg-slate-800/50'
                }`}
              >
                <item.icon className="w-5 h-5" />
                {item.label}
              </button>
            )
          ))}
        </div>
        <div className="flex justify-center items-center mt-2 pt-2 border-t border-slate-800 space-x-2">
            <button 
                onClick={onShowPrevious}
                className="flex-1 text-sm text-sky-400/90 hover:text-sky-300 flex items-center justify-center gap-2 py-2 px-3 rounded-lg hover:bg-slate-800/50 transition-colors"
            >
                <History className="w-5 h-5" />
                Ver Torneios
            </button>
            <div className="w-px h-6 bg-slate-800"></div>
            <button 
                onClick={() => setShowResetConfirm(true)} 
                className="flex-1 text-sm text-emerald-400/90 hover:text-emerald-300 flex items-center justify-center gap-2 py-2 px-3 rounded-lg hover:bg-slate-800/50 transition-colors"
            >
                <PlusSquare className="w-4 h-4" />
                Novo Torneio
            </button>
        </div>
      </nav>
    );
};
  
export default Navigation;
